import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IKBCatalogCategoryLearned } from '../../interfaces/IBase-knowledge-catalog';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'categories-bizagi-data',
  templateUrl: './categories-bizagi-data.component.html',
  styleUrls: ['./categories-bizagi-data.component.scss']
})
export class CategoriesBizagiDataComponent {
  @Input() filteredCategoryListBizagiData: IKBCatalogCategoryLearned[] = [];
  @Input() selectedItem: any = null;

  @Output() itemSelected = new EventEmitter<any>();
  @Output() itemRefresh = new EventEmitter<any>();

  constructor(private _i18nService: I18nService) { }

  toggleCategory(category: IKBCatalogCategoryLearned): void { category.Expanded = !category.Expanded; }
  trackByCategory = (_: number, cat: IKBCatalogCategoryLearned) => cat.DisplayName || cat.Id;
  trackByItem = (_: number, item: any) => item.Id || item.DisplayName;

  getSortedKBBizagiData(category: IKBCatalogCategoryLearned): any[] {
    return category.KBLearned ? [...category.KBLearned].sort((a: any, b: any) => a.DisplayName.localeCompare(b.DisplayName)) : [];
  }

  selectItem(item: any) { this.itemSelected.emit(item); }
  refreshItem(item: any, event?: Event) { if (event) { event.stopPropagation(); } this.itemRefresh.emit(item); }

  getFrecuencyTranslated(frecuency: any): string {
    return this._i18nService.instant('BASEKNOWLEDGECATALOG.' + String(frecuency).toUpperCase());
  }
}
